import { fromEvent, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * Reads file if one provided, otherwise returns value
 * @param value - string | File
 * @param isPdf - boolean
 * @returns Observable<any> - fileReader observable or value observable
 * @throws {Error}
 */
export const readThumbnailFromInput = (
  value: string | File,
  isPdf: boolean = false,
): Observable<any> => {
  if (value instanceof File) {
    if (isPdf) {
      const reader = new FileReader();
      const fileReader = fromEvent(reader, 'load').pipe(
        map((e: ProgressEvent<FileReader>) => e.target.result),
        take(1),
      );
      reader.readAsBinaryString(value);
      return fileReader;
    } else {
      // Use Object URL for non-PDF files for instant previews
      return of(URL.createObjectURL(value));
    }
  }

  return of(value);
};
